import {
  Card,
  Icon,
  StackLayout,
  TextAction,
  useClickableCard,
} from '@leagueplatform/genesis-core';
import { JOURNEY_ROUTES } from '@leagueplatform/health-journey-common';
import { LinkLegacy as Link } from '@leagueplatform/routing';
import { useProgramLibraryAnalytics } from '#hooks/use-program-library-analytics.hook.tsx';
import React from 'react';

interface CategoryCardProps {
  categoryId: string;
  name: string;
  iconUrl: string;
}

function CategoryCard({ categoryId, name, iconUrl }: CategoryCardProps) {
  const { primaryActionRef, clickAreaRef, onCardMouseDown, onCardMouseUp } =
    useClickableCard();

  const programLibraryAnalytics = useProgramLibraryAnalytics();
  return (
    <li key={categoryId}>
      <Card.Elevated backgroundColor="secondary" css={{ height: '100%' }}>
        <Card.ClickArea
          ref={clickAreaRef}
          onCardMouseUp={onCardMouseUp}
          onCardMouseDown={onCardMouseDown}
          css={{
            width: '100%',
            height: '100%',
            display: 'block',
            '&:hover': {
              backgroundColor: 'surface.background.secondary',
              textDecoration: 'none !important',
            },
            '&:focus': {
              backgroundColor: 'interactive.action.disabled',
            },
          }}
        >
          <StackLayout
            orientation="horizontal"
            horizontalAlignment="start"
            verticalAlignment="center"
            spacing="$half"
            css={{
              width: '100%',
              height: '100%',
              paddingY: '$oneAndHalf',
              paddingX: '$one',
            }}
          >
            <Icon icon={iconUrl} label="" size="$two" />

            <TextAction
              ref={primaryActionRef}
              as={Link}
              to={JOURNEY_ROUTES.getProgramCategory(categoryId)}
              onClick={() => {
                programLibraryAnalytics.sendSelectProgramCategory(name);
              }}
              css={{
                typography: '$headingThree',
                fontFamily: '$headings',
                color: '$interactiveActionSubdued',
              }}
            >
              {name}
            </TextAction>
          </StackLayout>
        </Card.ClickArea>
      </Card.Elevated>
    </li>
  );
}

export default CategoryCard;
